export default {
  API_RESOURCE: 'projects'
}
